import { Avatar, DropdownMenu } from "@/components/ui";
import { useSignOut, useUserOrThrow } from "@/lib/hooks/use-auth";
import { getNameInitials } from "@/lib/utils/string-utils";
import { LogOutIcon } from "lucide-react";
import { usePostHog } from "posthog-js/react";

export const UserMenu: React.FC = () => {
  const user = useUserOrThrow();
  const signOut = useSignOut();
  const posthog = usePostHog();

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger
        render={
          <button data-prevent-sidebar-expand className="cursor-pointer" type="button">
            <Avatar className="size-8 rounded-sm">
              <Avatar.Fallback className="rounded-sm bg-[#e6e6e6] dark:bg-secondary">
                {getNameInitials(user.fullName)}
              </Avatar.Fallback>
            </Avatar>
          </button>
        }
      />

      <DropdownMenu.Content className="w-56" align="end">
        <DropdownMenu.Label className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm leading-none font-medium">{user.fullName}</p>
            <p className="text-xs leading-none text-muted-foreground">
              {user.emailAddresses[0]?.emailAddress}
            </p>
          </div>
        </DropdownMenu.Label>

        <DropdownMenu.Separator />

        <DropdownMenu.Item
          onClick={() => {
            posthog.reset();
            void signOut();
          }}
        >
          <LogOutIcon className="mr-2 size-4" />
          Log out
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};
